import {
  ArrowRight,
  Briefcase_01,
  Check,
  RobinIcon,
  RobinLogoText,
  XClose,
} from '@recruit-robin/robin-theme/web-icons';
import { PoweredByRobin } from 'shared/ui/powered-by-robin';

import type { Vacancy } from 'clients/AutoCompleteClient/types';

import { Button, Divisor, Typography } from '@recruit-robin/robin-theme/web-components';
import { useContext } from 'react';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { useJobImprovedQuery } from 'shared/legacy/hooks/useJobImprovedQuery';
import { TenantLogo } from 'shared/ui/tenant-logo';
import { sanitizeEmailHtml } from 'utils/sanitizeEmailHtml';
import { useStyles } from './MessagePreview.styles';
import { useIsIndeedFlow } from '@/shared/legacy/contexts/CommAgentFlowContext';

export const MessagePreview = ({
  message,
  selectedVacancy,
  onViewVacancy,
}: {
  message: string;
  selectedVacancy: Vacancy;
  onViewVacancy: () => void;
}) => {
  const { dictionary } = useContext(LocalizationContext);
  const classes = useStyles();
  const { data: jobImproved } = useJobImprovedQuery(selectedVacancy.db_id);
  const primaryColorCss = TenantLogo.useColorsCss();
  const isIndeedFlow = useIsIndeedFlow();

  return (
    <div css={classes.root}>
      <div css={classes.logo}>
        <TenantLogo
          fallback={
            <>
              <RobinIcon size={28} />
              <RobinLogoText height={24} />
            </>
          }
        />
      </div>

      <Divisor customCss={classes.divisor} color={(c) => c.neutral.variant[30]} />

      <div css={[classes.vacancyDetails, primaryColorCss]} onClick={() => onViewVacancy()}>
        <div css={classes.vacancyDetailsTitle}>
          <Briefcase_01 size={18} />

          <Typography variant={(v) => v.body.short} inline>
            {jobImproved?.job_details?.job_title}
          </Typography>
        </div>

        <div css={classes.vacancyDetailsView}>
          <Typography variant={(v) => v.supporting.label} inline>
            {dictionary.viewFullJobDetails}
          </Typography>
          <ArrowRight size={18} />
        </div>
      </div>

      <div css={classes.message}>
        <Typography variant={(v) => v.body.short} color={(c) => c.neutral.variant[70]}>
          <span dangerouslySetInnerHTML={{ __html: sanitizeEmailHtml(message) }} />
        </Typography>
      </div>

      <div css={classes.buttons}>
        {isIndeedFlow ? (
          <Button
            label={dictionary.showQuestionnaire}
            onClick={console.log}
            style="filled"
            type="highlight-light"
            contained
            customCss={primaryColorCss}
          />
        ) : (
          <>
            <Button
              label={dictionary.interested}
              onClick={console.log}
              style="filled"
              type="highlight-light"
              startIcon={Check}
              contained
              customCss={primaryColorCss}
            />
            <Button
              label={dictionary.notInterested}
              onClick={console.log}
              style="text"
              type="subtle2"
              startIcon={XClose}
              contained
            />
          </>
        )}
      </div>

      <PoweredByRobin />
    </div>
  );
};
